<template>
  <div class="container">
    <hero-caroucel>
      <hero-caroucel-item-customer
        v-for="customer in CUSTOMER_REVIEWS"
        :key="customer.company_name"
        :bg-gradient="customer.bg_gradient"
        :person-image="
          `/images/customer-review/${customer.customer_name}_대표.png`
        "
      >
        <template v-slot:subtitle
          >{{ customer.company_name }}
          {{ customer.customer_name }} 대표님</template
        >
        <template v-slot:title>
          <span v-html="customer.title"></span>
        </template>
        <template v-slot:button>
          <button
            @click="onVideo(customer.youtube_code)"
            class="btn btn--white js-modal-video"
          >
            <span class="btn__icon">
              <img
                src="~assets/images/customer-review/ico-youtube.png"
                alt=""
              />
            </span>
            인터뷰 영상 보기 ({{ customer.video_time }})
          </button>
        </template>
      </hero-caroucel-item-customer>
    </hero-caroucel>
    <content-section bg-color="#fff">
      <customer-satisfaction />
    </content-section>

    <client-only>
      <content-section bg-color="#fafafa">
        <voc />
      </content-section>
    </client-only>

    <heum-join title="고객이 가장 만족한 혜움, 지금 바로 만나보세요." />
    <client-only>
      <video-modal :id="id" />
    </client-only>
  </div>
</template>

<script>
import HeroCaroucelItemCustomer from '@/components/hero-caroucel-item-customer'
import ContentSection from '~/components/common/content-section'
import HeumJoin from '~/components/heum-join'

import HeroCaroucel from '~/components/hero-caroucel'

import CustomerSatisfaction from '~/components/customer-review/customer-satisfaction'
import Voc from '~/components/customer-review/voc'

import ModalVideoMixin from '~/components/mixins/modal-video.js'

export default {
  layout: 'invert-font-header',
  head: {
    title: '고객리뷰 - 세무법인혜움'
  },
  components: {
    ContentSection,
    HeroCaroucel,
    HeroCaroucelItemCustomer,
    CustomerSatisfaction,
    Voc,
    HeumJoin
  },
  mixins: [ModalVideoMixin],
  data() {
    return {
      CUSTOMER_REVIEWS: [
        {
          title: '압도적으로 <br> 퀄리티가 높았어요',
          company_name: '(주)집사',
          customer_name: '이승권',
          youtube_code: 'lu780_GRoYA',
          video_time: '3:32',
          bg_gradient:
            '62.42% 149.6% at 32.21% 90.21%, #a19591 0%, #8f837e 42.71%, #7c726e 100%'
        },
        {
          title: '접했던 담당자 중에서 <br> 가장 잘 해주셨어요',
          company_name: '(주)스튜디오 봄봄',
          customer_name: '이선용',
          youtube_code: 'w7thcPKiIEg',
          video_time: '4:07',
          bg_gradient:
            '77.92% 186.74% at 29.05% 62.14%, #949494 0%, #757575 46.33%, #6B6666 100%'
        },
        {
          title: '스타트업을 가장 <br> 잘 아는 세무법인',
          company_name: '(주)이콰리',
          customer_name: '정근택',
          youtube_code: '2g0JV_NzEhs',
          video_time: '4:40',
          bg_gradient:
            '62.42% 149.6% at 32.21% 90.21%, #a19591 0%, #8f837e 42.71%, #7c726e 100%'
        },
        {
          title: '테크팀에 강점이 <br> 있는 세무법인',
          company_name: '(주)넷스트림',
          customer_name: '상현태',
          youtube_code: 'igIBau7HjIQ',
          video_time: '2:29',
          bg_gradient:
            '77.92% 186.74% at 29.05% 62.14%, #949494 0%, #757575 46.33%, #6B6666 100%'
        },
        {
          title: '혜움 덕분에<br> 정부지원사업도<br> 어렵지 않았어요',
          company_name: '(주)스위브',
          customer_name: '최형석',
          youtube_code: 'M_lAZ8Regjw',
          video_time: '4:41',
          bg_gradient:
            '62.42% 149.6% at 32.21% 90.21%, #a19591 0%, #8f837e 42.71%, #7c726e 100%'
        },
        {
          title: '혜움이 아니었으면<br /> 몰랐을거예요',
          company_name: '(주)랭코드',
          customer_name: '김민준',
          youtube_code: '7WnR7qr9kkE',
          video_time: '4:10',
          bg_gradient:
            '77.92% 186.74% at 29.05% 62.14%, #949494 0%, #757575 46.33%, #6B6666 100%'
        }
      ]
    }
  }
}
</script>
